/* esm.sh - svg-pathdata@9.0.0 */
export * from "/*svg-pathdata@9.0.0/esnext/svg-pathdata.mjs";
